import React from "react";

export type OptionKind = "cellar" | "club";

export const OPTION = {
  cellar: { label: "Cellar Plan", color: "var(--cellar)", dark: "var(--cellar-dark)", bg: "var(--cellar-bg)" },
  club: { label: "Wine Club", color: "var(--club)", dark: "var(--club-dark)", bg: "var(--club-bg)" },
} as const;

export function OptionBadge({ kind, text, className = "", testId }: { kind: OptionKind; text?: string; className?: string; testId?: string }) {
  const o = OPTION[kind];
  return (
    <span className={`inline-block border px-2 py-1 text-[10px] uppercase tracking-[0.2em] ${className}`}
      style={{ color: o.dark, borderColor: `${o.color}66`, background: o.bg }} data-testid={testId || `option-badge-${kind}`}>
      {text || o.label}
    </span>
  );
}

export function OptionRule({ kind }: { kind: OptionKind }) {
  return <div className="h-1 w-16" style={{ background: OPTION[kind].color }} aria-hidden />;
}
